import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './Button.scss'

const Button = ({
  children,
  text,
  onClick,
  type,
  className,
  positive,
  negative,
  big,
  disabled,
  icon,
  id,
}) => {
  let classes = className

  classes = positive ? `positive-button ${classes}` : classes
  classes = negative ? `negative-button ${classes}` : classes
  classes = big ? `big-button ${classes}` : classes
  classes = disabled ? `disabled-button ${classes}` : classes

  return (
    <button
      id={id}
      className={`button ${classes}`}
      onClick={onClick}
      disabled={disabled}
      type={type || 'button'}
    >
      {
        icon && <FontAwesomeIcon icon={icon} />
      }
      <span>{text || children}</span>
    </button>
  )
}

Button.defaultProps = {
  id: '',
  icon: null,
  type: '',
  text: '',
  className: '',
  children: null,
  onClick: null,
  positive: false,
  negative: false,
  disabled: false,
  big: false,
}

Button.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.any,
  type: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  positive: PropTypes.bool,
  negative: PropTypes.bool,
  disabled: PropTypes.bool,
  big: PropTypes.bool,
}

export default Button



// WEBPACK FOOTER //
// ./src/browser/components/Button.js